import { Component, OnInit, Input } from '@angular/core';
import { ListingCategory, SCREEN_SIZE } from '../../classes/enums';
import { Router, NavigationEnd, Event } from '@angular/router';
import { HasSubscriptions } from '../has-subscriptions';
import { DomManipulationService } from '../../services/dom-manipulation/dom-manipulation.service';
import { filter } from 'rxjs/operators';
import {CommunicationService} from '../../services/communication.service';
import { ListingsService } from '../../services/listings.service';
import { PreRenderService } from '../../services/pre-render.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss' , './footer.desktop.component.scss', './footer.mobile.component.scss']
})
export class FooterComponent extends HasSubscriptions implements OnInit {
  @Input() currentShownListingType: ListingCategory;
  @Input() screenSize: SCREEN_SIZE;
  @Input() provinces: string[] = [];

  // Specifically for gallery desktop where on map view, the footer needs to be shown in mobile mode on desktop
  @Input() shouldShowMobileVersion: boolean = false;
  isBrowser: boolean;

  showCanadaLocations: boolean = false;
  showSiteSections: boolean = false;
  showLegal: boolean = false;
  showCorporate: boolean = false;
  idxDisclosure: string;
  currentYear = new Date().getFullYear();
  isEdmonton: boolean = false;
  // Enums
  ListingCategory = ListingCategory;
  SCREEN_SIZE = SCREEN_SIZE;

  constructor(private _router: Router,
              private _domManipulationService: DomManipulationService,
              private communicationService: CommunicationService,
              private _listingService: ListingsService,
              private preRenderService: PreRenderService) {
    super();
    this.isBrowser = this.preRenderService.isBrowserMode;
  }

  ngOnInit() {
    this.addSub(this._router.events
      .pipe(filter((e: Event) => e instanceof NavigationEnd))
      .subscribe((e: NavigationEnd) => {
        this.toggleDropdown();
        this._domManipulationService.scrollToTop();
      }));
      this.addSub(this.communicationService.listings.isEdmontonBoard.subscribe(id => {
        if (!id) {
          this.isEdmonton = false;
          return;
        };

        this.isEdmonton = true;

        if (this.idxDisclosure) return;

        this._listingService.getListingDetails(id)
        .then(listing => {
           this.idxDisclosure = listing.idxDisclosure;
        })
        .catch(() => {
          this.idxDisclosure = '';
        });
       }));
  }

  // TODO: add in nice animatinos like celso has for the desktop sub nav
  toggleDropdown(category?) {
    switch (category) {
      case 'canadaLocations': {
        this.showCanadaLocations = !this.showCanadaLocations;
        break;
      }
      case 'siteSections': {
        this.showSiteSections = !this.showSiteSections;
        break;
      }
      case 'legal': {
        this.showLegal = !this.showLegal;
        break;
      }
      case 'corporate': {
        this.showCorporate = !this.showCorporate;
        break;
      }
      default: {
        this.showCanadaLocations = false;
        this.showSiteSections = false;
        this.showLegal = false;
        this.showCorporate = false;
      }
    }
  }

  openQuebecModal() {
    this.communicationService.notifications.showQuebecModal.next(true);
  }
}
